import styled from 'styled-components';
import breakpoints from '../utils/miniBreakpoints';

const { mobile } = breakpoints;


const ClickthroughWrapper = styled.a`
    text-decoration: none;
    color: inherit;
    display: block;
    width: 100%;
    height: 100%;
    @media (max-width: ${mobile}) {
        width: ${({ theme }) => theme.width};
        position: absolute;
        box-sizing: border-box !important;
    }
    
    span {
        &:not(:last-child) {
            &::after {
                content: " ";
            }
        }
        @media (max-width: ${mobile}) {
            display: ${({ isRefresh }) => isRefresh ? 'auto' : 'block'};
        }
    }
`;

export default ClickthroughWrapper;
